import React, { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useValidateMutation } from "../../hooks/sign-up";
import { useIsMobileView } from "../hooks";
import {
  ProfessionalSmallViewParallax,
  ProfessionalLargeViewParallax,
} from "./parallax";
import "../styles.css";

export const ProfessionalLanding: React.FC = () => {
  const mobileView = useIsMobileView();
  const { mutate: validateTokenMutation } = useValidateMutation();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      validateTokenMutation(token);
      return;
    }
  }, [searchParams, validateTokenMutation]);

  return useMemo(
    () =>
      mobileView ? (
        <ProfessionalSmallViewParallax />
      ) : (
        <ProfessionalLargeViewParallax />
      ),
    [mobileView]
  );
};
